const springEndPoint = {
    // "host": 'http://' + window.location.host 
   // host: "http://localhost:8080"
   "host": "https://mrc-fabrics.herokuapp.com"
  }
export {
  springEndPoint
};
